import { Button } from "antd";
import React, { Fragment, useState } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import Call from "../../../hocs/call";
import { MARGIN_MD, MODAL_WIDTH_LG } from "../../../styles/constants";
import EnhancedModal from "../../enhanced-modal";
import {readELConcepts, readELConceptSchemes, resetELConcepts, setELSemanticColumnsConcept} from "../actions";
import { EL_SEMANTIC_CONCEPT_EXISTING } from "../constants";
import ArtefactList from "../../artefact-list";
import ELSemanticStepTable from "./Table";
import ArtefactSummary from "../../../components/artefact-summary";
import ItemList from "../../item-list";

const mapStateToProps = state => ({
  structureColumns: state.scenes.easyLoading.structureColumns,
  permissions: state.app.user.permissions,
  conceptSchemes: state.scenes.easyLoading.structureConceptSchemes,
  concepts: state.scenes.easyLoading.structureConcepts
});

const mapDispatchToProps = dispatch => ({
  onChange: (columnId, conceptType, conceptName, conceptLang, conceptSchema, concept) =>
    dispatch(setELSemanticColumnsConcept(columnId, conceptType, conceptName, conceptLang, conceptSchema, concept)),
  onConceptSchemesFetch: () => dispatch(readELConceptSchemes()),
  onConceptsFetch: (csTriplet) => dispatch(readELConcepts(csTriplet)),
  onClearConcepts: () => dispatch(resetELConcepts())
});

const ELSemanticStep = ({
  t,
  structureColumns,
  permissions,
  conceptSchemes,
  concepts,
  onChange,
  onConceptSchemesFetch,
  onConceptsFetch,
  onClearConcepts
}) => {
  
  const canCreateConcepts = permissions && permissions.rules && permissions.rules.includes("CanUpdateStructuralMetadata");
  const [columnIdToAssociateConceptSchema, setColumnIdToAssociateConceptSchema] = useState(null);
  const [columnIdToAssociateConcept, setColumnIdToAssociateConcept] = useState(null);
  const [currentConceptSchema, setCurrentConceptSchema] = useState(null);


  return (
    <Call cb={onConceptSchemesFetch} disabled={conceptSchemes !== null}>
      <Fragment>
        <ELSemanticStepTable
          structureColumns={structureColumns}
          canCreateConcepts={canCreateConcepts}
          setColumnIdToAssociateConceptSchema={setColumnIdToAssociateConceptSchema}
          onChange={onChange}
        />
        <EnhancedModal
          visible={columnIdToAssociateConceptSchema !== null}
          onCancel={() => setColumnIdToAssociateConceptSchema(null)}
          title={t("components.easyLoading.semantic.table.modals.conceptScheme.title")}
          width={MODAL_WIDTH_LG}
          footer={
            <Button onClick={() => setColumnIdToAssociateConceptSchema(null)}>
              {t("commons.buttons.close.title")}
            </Button>
          }
        > 
          <ArtefactList
            artefacts={conceptSchemes}
            onRowClick={conceptSchema => {
                const rowId = columnIdToAssociateConceptSchema;
                onChange(
                  rowId,
                  EL_SEMANTIC_CONCEPT_EXISTING,
                  null,
                  null,
                  conceptSchema,
                  null
                );
                setCurrentConceptSchema(conceptSchema);
                setColumnIdToAssociateConcept(rowId);
              }              
            }
            getIsDisabledRow={({isFinal}) => !isFinal}
          />
        </EnhancedModal>
        <EnhancedModal
          visible={columnIdToAssociateConcept !== null}
          onCancel={() => setColumnIdToAssociateConcept(null)}
          title={t("components.easyLoading.semantic.table.modals.concept.title")}
          width={MODAL_WIDTH_LG}
          footer={
            <Button onClick={() => {
              onClearConcepts();
              setColumnIdToAssociateConcept(null)
            }}>
              {t('commons.buttons.close.title')}
            </Button>}
        >
          <Call 
            cb={onConceptsFetch}
            cbParam={currentConceptSchema}
          >
            {(() => {
              
              if (currentConceptSchema === null) {
                return null;
              }
              return (
                <div style={{marginBottom: MARGIN_MD}}>
                  <ArtefactSummary
                    id={currentConceptSchema.id}
                    agencyID={currentConceptSchema.agencyID}
                    version={currentConceptSchema.version}
                  />
                </div>
              );
            })()}
            <ItemList
              data={concepts}
              hideOrderCol
              onRowClick={concept => {
                  onChange(
                    columnIdToAssociateConcept,
                    EL_SEMANTIC_CONCEPT_EXISTING,
                    null,
                    null,
                    currentConceptSchema,
                    concept
                  );
                  setColumnIdToAssociateConcept(null);
                  setColumnIdToAssociateConceptSchema(null);
                }
              }
            />
          </Call>
        </EnhancedModal>
      </Fragment>
    </Call>
  );
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ELSemanticStep);


// WEBPACK FOOTER //
// ./src/components/easy-loading/semantic-step/index.jsx